<template>
  <ContentWrap>
    <el-alert
      type="info"
      :closable="false"
      show-icon
      title="会员线（MEMBER）二级分销：计佣来源为平台内消费。一级/二级比例按「分销等级」配置，本页只管开关、绑定、冻结与提现门槛。"
      class="mb-15px"
    />
    <el-form v-loading="loading" :model="form" label-width="140px" class="max-w-720px">
      <el-form-item label="启用分销">
        <el-switch v-model="form.enabled" />
      </el-form-item>
      <el-form-item label="绑定模式">
        <el-radio-group v-model="form.bindMode">
          <el-radio :value="1">首次绑定</el-radio>
          <el-radio :value="2">注册绑定</el-radio>
          <el-radio :value="3">可覆盖</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="合计上限 %">
        <el-input-number v-model="form.maxTotalRate" :min="0" :max="100" />
      </el-form-item>
      <el-form-item label="冻结天数">
        <el-input-number v-model="form.frozenDays" :min="0" :max="365" />
      </el-form-item>
      <el-form-item label="最低提现（分）">
        <el-input-number v-model="form.withdrawMin" :min="0" :step="100" />
        <span class="ml-10px text-gray-400">当前约 ¥{{ ((form.withdrawMin || 0) / 100).toFixed(2) }}</span>
      </el-form-item>
      <el-form-item label="分销商资格费（分）">
        <el-input-number v-model="form.joinFee" :min="0" :step="100" />
        <span class="ml-10px text-gray-400">当前约 ¥{{ ((form.joinFee || 0) / 100).toFixed(2) }}（0=免支付直进审核）</span>
      </el-form-item>
      <el-form-item label="平台头像">
        <div>
          <UploadImg v-model="form.platformAvatar" />
          <div class="el-upload__tip mt-6px" style="line-height: 1.4">
            小程序「成为分销商」页无上级时展示；清空后回退默认 Logo
          </div>
        </div>
      </el-form-item>
      <el-form-item label="计佣白名单">
        <el-input
          v-model="form.basisWhitelist"
          type="textarea"
          :rows="2"
          placeholder="如 SHOP,CIRCLE_JOIN,CIRCLE_OWNER"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          v-hasPermi="['bosscircle:dist-track-config:update']"
          :loading="saving"
          @click="save"
        >
          保存
        </el-button>
        <el-button @click="load">刷新</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
</template>

<script setup lang="ts">
import * as Api from '@/api/business/distTrackConfig'

defineOptions({ name: 'BusinessDistTrackConfig' })

const message = useMessage()
const loading = ref(false)
const saving = ref(false)
const form = reactive<Api.DistTrackConfigVO>({
  enabled: true,
  maxLevel: 2,
  bindMode: 1,
  l1Rate: 10,
  l2Rate: 5,
  maxTotalRate: 30,
  frozenDays: 7,
  withdrawMin: 100,
  joinFee: 9900,
  platformAvatar: '',
  basisWhitelist: 'SHOP,CIRCLE_JOIN,CIRCLE_OWNER,DIST_JOIN'
})

const load = async () => {
  loading.value = true
  try {
    const data = await Api.getDistTrackConfig('MEMBER')
    Object.assign(form, data || {})
    form.maxLevel = 2
    form.l3Rate = 0
    if (form.joinFee == null) form.joinFee = 9900
  } finally {
    loading.value = false
  }
}

const save = async () => {
  saving.value = true
  try {
    await Api.updateDistTrackConfig(
      {
        ...form,
        maxLevel: 2,
        l3Rate: 0
      },
      'MEMBER'
    )
    message.success('保存成功')
    await load()
  } finally {
    saving.value = false
  }
}

onMounted(load)
</script>
